import { COLORS } from '~/data/ui/colors';
import theme from '~/theme';
import React, { CSSProperties } from 'react';
import { styled } from '@mui/material';
import { scrollBar as scrollBarStyle } from '~/styles/useStyleGlobal';
import { scrollBarMini } from '~/styles/useStyleGlobal';

const useStyles = () => ({
  filtersContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    width: '100%',
    zIndex: 99,
    [theme.breakpoints.up('md')]: {
      padding: '0 ',
    },
    [theme.breakpoints.down('md')]: {
      backgroundColor: 'white',
    },
  },
  filtersMobileView: {
    width: 'calc(100vw + 21%)',
    overflowX: 'auto',
    overflowY: 'hidden',
    whiteSpace: 'nowrap',
    scrollbarWidth: 'none',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'row',
    gap: '5px',
    boxShadow: ' 0px 0px 0px rgb(0 0 0 / 4%)',
    padding: '6px 0 0px',
    transform: 'scale(.8)',
    alignSelf: 'center',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
    ...scrollBarMini,
  },
  accordionCustomStyle: {
    border: 'none',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  accordionTypography: {
    height: '50px',
    padding: '1%',
    '&:hover': {
      background: COLORS.gray.light,
      cursor: 'pointer',
    },
  },
  filterButton: {
    border: `1px solid ${theme.palette.primary.dark}`,
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'space-evenly',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    width: '108px',
    backgroundColor: theme.palette.primary.contrastText,
    height: '40px',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  filtersDesktopView: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      padding: '16px 1.7%',
      backgroundColor: `${COLORS.white.main}`,
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      justifyContent: 'right',
      '&.MuiFormControl-root': {
        flexDirection: 'row',
      },
    },
    [theme.breakpoints.up('lg')]: {
      gap: '8px',
    },
  },
  filtersDesktopContainer: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      position: 'relative',
      alignItems: 'start',
      zIndex: '120',
      backgroundColor: '#ffffff',
    },
  },
  filtersDetailsView: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginRight: '10px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.04)',
    // [theme.breakpoints.down('md')]: {
    //   marginRight: '10px',
    //   boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.04)',
    // },
    [theme.breakpoints.up('md')]: {
      marginRight: 'auto',
      boxShadow: '0px 0px 0px rgba(0, 0, 0, 0)',
      flexDirection: 'row',
      maxWidth: '1910px',
    },
  },
  allResults: {
    textAlign: 'right',
    width: '100%',
    padding: '6px 0',
    [theme.breakpoints.up('md')]: {
      backgroundColor: `${COLORS.gray.light7}`,
    },
  },
  sortBySection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
    width: '100%',
    textAlign: 'center',
    paddingLeft: '100px',
    padding: '6px 0',
    gap: '6px',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'left',
    },
  },
  MoreFiltersContainerStyle: {
    display: 'flex',
    marginLeft: '16px',
    alignItems: 'center',
  },
  filtersGroupWrapper: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    gap: '2.5vw',
  },
  moreFiltersWrapper: {
    flexDirection: 'row',
    display: 'flex',
    borderTop: `1px solid ${COLORS.gray.light2}`,
    padding: '16px 0 0px',
    width: '100%',
    gap: '8px',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginTop: '16px',
  },
  showFiltersButton: {
    paddingRight: '8px',
  },
  firstLineFiltersWrapper: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: '8px',
  },
});

export const scrollBar = scrollBarStyle;

export const filtersButtonStyle: React.CSSProperties = {
  border: `1px solid ${theme.palette.primary.dark}`,
  borderRadius: '8px',
  justifyContent: 'space-evenly',
  flexDirection: 'row-reverse',
  alignItems: 'center',
  height: '40px',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  minWidth: '145px',
  marginLeft: '4px',
  backgroundColor: '#F5F8F9 !important',
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
};

export const allFiltersFontButtonStyle: React.CSSProperties = {
  fontSize: '18px',
};

export const customFiltersFormMobile = {
  height: '30px',
  fontSize: '16px',
  padding: '0 16px',
  width: 'max-content',

  '& svg': {
    top: '4px !important',
  },

  '& #dd-options': {
    top: '31px',

    '& p': {
      fontSize: '15px',
    },
  },

  '& h5': {
    transform: 'scale(0.8)',
    top: '5px',
    left: '30px',
  },

  '& #checkboxClearFilter svg': {
    transform: 'scale(0.8)',
  },
};

export const customFiltersTextMobile = {
  fontSize: '16px',
  marginTop: '-2px',
};

export const sortTextStyle: React.CSSProperties = {
  fontWeight: 400,
  color: COLORS.gray.main,
};

export const sortByTextStyle: React.CSSProperties = {
  fontSize: '20px',
};
export const cleanAllFiltersDesktopStyle: React.CSSProperties = {
  fontWeight: '800',
  fontSize: '18px !important',
  color: `${COLORS.black.dark}`,
};
export const allResultsTextStyle: React.CSSProperties = {
  fontWeight: 400,
  color: `${COLORS.gray.dark}`,
  paddingTop: '5px',
  paddingBottom: '5px',
  fontSize: '16px',
};

export const filterSummary = {
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  direction: 'rtl',
};

export const moreFiltersButtonStyle = {
  flexDirection: 'row',
  gap: '8px',
  border: `1px solid ${COLORS.gray.dark} !important`,
  borderRadius: '8px',
  padding: '9px 11px 5px 5px',
  fontWeight: '800',
  fontSize: '16px',
  color: `${COLORS.black.dark}`,
  textAlign: 'end',
  height: '40px',
  '&:hover': {
    border: ` 1px solid ${COLORS.primary.main} !important`,
    background: `${COLORS.white}`,
  },
  '&:focus': {
    border: ` 1px solid ${COLORS.primary.main}`,
  },
};

export const moreFiltersSelectedButtonStyle = {
  border: `1px solid ${COLORS.primary.main}`,
};

export const onlyImageCheckboxStyle = {
  fontSize: '16px',
  color: `${COLORS.gray.light2}`,
  borderRadius: '8px',
  '& .MuiSvgIcon-root': {},
  '&.Mui-checked': {
    color: `${COLORS.primary.main} `,
  },
};

export const formControlLabelStyle = {
  marginLeft: 'auto',
  marginRight: 'unset',
  fontSize: '16px',
  '& .MuiFormControlLabel-label': { fontSize: '16px' },
};
export default useStyles;

export const ShowFilterIcon = styled('svg')(() => ({
  marginRight: '8px',
}));

export const ShowFiltersButtonStyle = styled('svg')(() => ({
  transform: 'scale(1.15)',
  marginRight: '2px',
}));

export const CircleCountWidget = styled('div')(() => ({
  position: 'relative',
}));
export const CircleCountStyle: CSSProperties = {
  position: 'absolute',
  left: -5,
  top: -10,
  zIndex: 2,
};

export const checkBoxCustomStyles = {
  width: '215px',
};
export const checkBoxHighLightStyles = {
  width: '245px',
};

export const topFiltersStyle = {
  height: '40px',

  '& div div p': {
    marginTop: '1px',
  },
};

export const topFiltersStyleMobile = {
  height: '40px',

  '& p': {},

  '& div div p': {},
};
